var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopNavBar'),_c('h1',[_vm._v("Hello")]),_c('img',{attrs:{"alt":"Vue logo","src":"/assets/logo.png"}}),_c('BottomNavBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }